import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ink text-background/85 mt-24">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 pb-16 border-b border-white/15">
          <div className="md:col-span-1">
            <div className="font-display text-[36px] font-medium tracking-[0.04em] mb-4 text-background">Besq</div>
            <p className="text-[13px] leading-[1.75] opacity-70 max-w-xs">
              Premium custom tailoring, crafted with care and delivered to your doorstep.
            </p>
          </div>
          <FooterCol title="Explore" links={[
            { to: '/categories', label: 'All Categories' },
            { to: '/categories/blouse', label: 'Blouse' },
            { to: '/categories/lehenga', label: 'Lehenga' },
            { to: '/categories/suit', label: 'Suit' },
          ]} />
          <FooterCol title="The House" links={[
            { to: '/about', label: 'Our Story' },
            { to: '/about', label: 'By Appointment' },
            { to: '/about', label: 'Contact' },
          ]} />
          <FooterCol title="Care" links={[
            { to: '/about', label: 'Sizing' },
            { to: '/about', label: 'Delivery' },
            { to: '/about', label: 'Alterations' },
            { to: '/about', label: 'FAQs' },
          ]} />
        </div>

        <div className="font-display font-light select-none text-center leading-none opacity-[0.10] mt-10"
             style={{ fontSize: 'clamp(80px, 20vw, 220px)', letterSpacing: '0.08em' }}>
          BESQ
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 gap-3 text-[12px] opacity-55">
          <div>© {new Date().getFullYear()} Besq. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/about" className="hover:opacity-100">Privacy</Link>
            <Link to="/about" className="hover:opacity-100">Terms</Link>
            <Link to="/about" className="hover:opacity-100">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="uppercase tracking-luxe text-[11px] font-medium opacity-70 mb-6">{title}</h4>
      <ul className="flex flex-col gap-3">
        {links.map((l, i) => (
          <li key={i}>
            <Link to={l.to} className="text-[14px] opacity-85 hover:opacity-100 hover:text-[hsl(var(--gold))] transition-colors">
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
